import styled from 'styled-components'
import GImage from 'components/common/gImage'
import { FlexColumn, Section } from 'components/common/common_styles'
import { gutter, sizeMobile } from 'components/globalStyles'
import { fontClamp } from 'utils/textUtils'

export const MainContainer = styled(Section)`
  display: grid;
  position: relative;
`

export const HeroVideo = styled.video`
  grid-area: 1 / -1;
`

export const HeroImage = styled(GImage)`
  grid-area: 1 / -1;
`

export const VideoOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  grid-area: 1 / -1;
`

export const ButtonContainer = styled.div`
  justify-self: end;
  align-self: end;
  margin-right: 32px;
  margin-bottom: 32px;
  z-index: 1;
  grid-area: 1 / -1;

  @media (max-width: 870px) {
    margin-bottom: 120px;
  }

  @media (max-width: ${sizeMobile}) {
    margin-bottom: 32px;
  }
`

export const TextContainer = styled(FlexColumn)`
  grid-area: 1 / -1;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 1;
  padding: ${gutter};
  text-align: center;

  & > h1,
  & > hr {
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.45));
  }
`

export const Divider = styled.hr`
  width: 53px;
  height: 1px;
  border: none;
  background-color: white;
`

export const UpperText = styled.p`
  font-family: Garamond;
  font-size: ${fontClamp(2.4, 3.2)};
  line-height: 1.15em;
  letter-spacing: 0.225em;
  text-transform: uppercase;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.45));
`

export const BookingWidgetContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: -32px;
  width: fit-content;
  transform: translateX(-50%);
  z-index: 1;

  @media (max-width: ${sizeMobile}) {
    display: none;
  }
`

export const MainText = styled.h1`
  font-size: calc(${props => props.scale} * ${fontClamp(6.4, 9.2)});
`